import { CDataTable } from '@coreui/vue'

/**
 * 表（CDataTable）が空のときの文言を日本語にする。
 *
 * CoreUI の表は、0件のときに英語の「No items」を出す（部品に直書きで、
 * 文言を変える設定が無い）。運営の請求管理や、契約企業が見る
 * 「請求・お支払い」で、そのまま英語が出ていた（2026-09-18）。
 *
 * **表ごとに書き足すと、次に足す表でまた漏れる。**部品の登録そのものを
 * 包んで、空のときの枠を既定で差し込む。画面側が自分で空の枠を
 * 書いていれば、そちらを使う。
 *
 * 一部の画面は `no-items-view="契約企業がありません。"` と文字で渡して
 * いたが、この版の部品はそれを読まない。ここで拾って表示に使う。
 */
export const EMPTY_TEXT = '表示するデータがありません。'

export default {
  install (Vue) {
    Vue.component('CDataTable', {
      name: 'CDataTableJa',
      functional: true,
      render (h, context) {
        const data = Object.assign({}, context.data)
        const attrs = Object.assign({}, data.attrs)
        const text = typeof attrs['no-items-view'] === 'string' && attrs['no-items-view'].trim()
          ? attrs['no-items-view']
          : EMPTY_TEXT
        delete attrs['no-items-view']
        data.attrs = attrs
        data.scopedSlots = Object.assign({
          'no-items-view': () => h('div', { staticClass: 'text-center text-muted my-4' }, text)
        }, context.data.scopedSlots)
        return h(CDataTable, data, context.children)
      }
    })
  }
}
